import { Link } from 'react-router-dom';

export default function PublicFooter() {
  return (
    <footer className="bg-midnight-surface border-t border-midnight-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-bold text-accent">VideoQR</span>
            <p className="mt-2 text-sm text-text-secondary">
              Permanent QR codes for video, photos, and links.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/discover" className="text-sm text-text-secondary hover:text-white transition-colors">
                  Discover
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-text-secondary hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/free-qrcodes" className="text-sm text-text-secondary hover:text-white transition-colors">
                  Free QR Generator
                </Link>
              </li>
              <li>
                <a href="https://apps.apple.com/us/app/video-qr-studio/id6761097249" target="_blank" rel="noopener noreferrer" className="text-sm text-text-secondary hover:text-white transition-colors">
                  iOS App
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-text-secondary hover:text-white transition-colors">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-text-secondary hover:text-white transition-colors">
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/support" className="text-sm text-text-secondary hover:text-white transition-colors">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/status" className="text-sm text-text-secondary hover:text-white transition-colors">
                  Status
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-8 border-t border-midnight-border flex items-center justify-center">
          <p className="text-sm text-text-tertiary">
            2026 VideoQR. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
